import { Feature } from '@nirvana/shared/constants';

export enum Column {
  TASK_NAME,
  TASK_TYPE,
  STATUS,
  START_DATE,
  COMPANIES,
  PROGRESS,
  OWNER,
}

export enum ColumnKeys {
  TASK_NAME = 'taskName',
  TASK_TYPE = 'type',
  STATUS = 'status',
  START_DATE = 'startDate',
  COMPANIES = 'companies.name',
  PROGRESS = 'progress',
  OWNER = 'ownerUserName',
}

export interface GridCellLabel {
  label: string;
  value: number;
}

export enum TaskType {
  TASK_TYPE_SCAN_PARENT = 256,
  TASK_TYPE_STOP_SCAN_PARENT = 688,
  TASK_TYPE_SCAN_CHILD = 272,
  TASK_TYPE_SCAN_VSHIELD_CHILD = 512,
  TASK_TYPE_SCAN_SVE_CHILD = 513,
  TASK_TYPE_SCAN_EXCHANGE_PARENT = 864,
  TASK_TYPE_SCAN_EXCHANGE_CHILD = 865,
  TASK_TYPE_STOP_SCAN_EXCHANGE_PARENT = 866,
  TASK_TYPE_INSTALL_ENDPOINT_PARENT = 769,
  TASK_TYPE_INSTALL_ENDPOINT_CHILD = 785,
  TASK_TYPE_INSTALL_ENDPOINT_SUPA_PARENT = 848,
  TASK_TYPE_INSTALL_ENDPOINT_SUPA_CHILD = 849,
  TASK_TYPE_UPGRADE_ENDPOINT_PARENT = 880,
  TASK_TYPE_RESTART_ENDPOINT_PARENT = 258,
  TASK_TYPE_DELETE_ENDPOINT_PARENT = 259,
  TASK_TYPE_UNINSTALL_ENDPOINT_PARENT = 260,
  TASK_TYPE_UPDATE_ENDPOINT_PARENT = 261,
  TASK_TYPE_MODIFY_INSTALLER_ENDPOINT_PARENT = 262,
  TASK_TYPE_RESTORE_QUARANTINE_PARENT = 264,
  TASK_TYPE_REMOVE_QUARANTINE_PARENT = 265,
  TASK_TYPE_NETWORK_DISCOVERY_PARENT = 266,
  TASK_TYPE_REMOVE_QUARANTINE_EXCHANGE_PARENT = 267,
  TASK_TYPE_RESTORE_QUARANTINE_EXCHANGE_PARENT = 268,
  TASK_TYPE_SAVE_QUARANTINE_EXCHANGE_PARENT = 269,
  TASK_TYPE_SAVE_QUARANTINE_EXCHANGE_CHILD = 285,
  TASK_TYPE_APPLICATION_DISCOVERY_PARENT = 270,
  TASK_TYPE_APPLICATION_DISCOVERY_CHILD = 286,
  TASK_TYPE_REPAIR_ENDPOINT_PARENT = 1054977,
  TASK_TYPE_REPAIR_ENDPOINT_CHILD = 1054976,
  TASK_TYPE_SANDBOX_FILE_SUBMISSION_PARENT = 271,
  TASK_TYPE_SANDBOX_FILE_SUBMISSION_CHILD = 287,
  TASK_TYPE_REMOVE_ALL_QUARANTINE_PARENT = 297,
  TASK_TYPE_REMOVE_ALL_QUARANTINE_CHILD = 313,
  TASK_TYPE_REMOVE_ALL_QUARANTINE_EXCHANGE_PARENT = 299,
  TASK_TYPE_REMOVE_ALL_QUARANTINE_EXCHANGE_CHILD = 315,
  TASK_TYPE_INSTALL_EPS_PARENT = 257,
  TASK_TYPE_INSTALL_EPS_SUPA_PARENT = 336,
  TASK_TYPE_ADD_REMOVE_FEATURES_ENDPOINT_PARENT = 518,
  TASK_TYPE_ADD_REMOVE_FEATURES_ENDPOINT_CHILD = 534,
  TASK_TYPE_INSTALL_SAGENT_PARENT = 544,
  TASK_TYPE_DEPLOY_VMWARE_SVA_PARENT = 576,
  TASK_TYPE_UNDEPLOY_VMWARE_SVA_PARENT = 608,
  TASK_TYPE_DEPLOY_XEN_SVA_PARENT = 592,
  TASK_TYPE_UNDEPLOY_XEN_SVA_PARENT = 624,
  TASK_TYPE_DEPLOY_NUTANIX_SVA_PARENT = 705,
  TASK_TYPE_DEPLOY_NUTANIX_SVA_CHILD = 706,
  TASK_TYPE_UNDEPLOY_NUTANIX_SVA_PARENT = 707,
  TASK_TYPE_UPDATE_SVA_PARENT = 626,
  TASK_TYPE_UPDATE_SANDBOX_PARENT = 1049088,
  TASK_TYPE_UPDATE_GHOSTR_PARENT = 1049344,
  TASK_TYPE_BUILD_DETONATION_IMAGE_PARENT = 1049600,
  TASK_TYPE_BUILD_DETONATION_IMAGE_CHILD = 1049601,
  TASK_TYPE_SET_DEFAULT_DETONATION_IMAGE_PARENT = 1050112,
  TASK_TYPE_SET_DEFAULT_DETONATION_IMAGE_CHILD = 1050113,
  TASK_TYPE_DELETE_DETONATION_IMAGE_PARENT = 1050624,
  TASK_TYPE_DELETE_DETONATION_IMAGE_CHILD = 1050625,
  TASK_TYPE_ADD_QUARANTINE_PARENT = 1054721,
  TASK_TYPE_ADD_QUARANTINE_CHILD = 1054722,
  TASK_TYPE_PATCH_SCAN_PARENT = 320,
  TASK_TYPE_PATCH_SCAN_CHILD = 321,
  TASK_TYPE_PATCH_INSTALL_PARENT = 322,
  TASK_TYPE_PATCH_INSTALL_CHILD = 323,
  TASK_TYPE_PATCH_UNINSTALL_PARENT = 324,
  TASK_TYPE_ISOLATE_ENDPOINT_PARENT = 1281,
  TASK_TYPE_ISOLATE_ENDPOINT_CHILD = 1282,
  TASK_TYPE_RESTORE_ENDPOINT_PARENT = 1283,
  TASK_TYPE_RESTORE_ENDPOINT_CHILD = 1284,
  TASK_TYPE_KILL_PROCESS_PARENT = 1048832,
  TASK_TYPE_KILL_PROCESS_CHILD = 1048833,
  TASK_TYPE_IOR_SCAN_PARENT = 1050880,
  TASK_TYPE_IOR_SCAN_CHILD = 1050881,
  TASK_TYPE_IOR_FIX_PARENT = 1052672,
  TASK_TYPE_IOR_FIX_CHILD = 1052673,
  TASK_TYPE_IOR_ROLLBACK_PARENT = 1052688,
  TASK_TYPE_IOR_ROLLBACK_CHILD = 1052689,
  TASK_TYPE_IOC_SCAN_PARENT = 1054208,
  TASK_TYPE_IOC_SCAN_CHILD = 1054209,
  TASK_TYPE_TROUBLESHOOT_GATHER_EXISTING_LOGS_PARENT = 1052928,
  TASK_TYPE_TROUBLESHOOT_GATHER_EXISTING_LOGS_CHILD = 1052929,
  TASK_TYPE_TROUBLESHOOT_START_DEBUG_SESSION_PARENT = 1053184,
  TASK_TYPE_TROUBLESHOOT_START_DEBUG_SESSION_CHILD = 1053185,
  TASK_TYPE_TROUBLESHOOT_FINISH_DEBUG_SESSION_PARENT = 1053440,
  TASK_TYPE_TROUBLESHOOT_FINISH_DEBUG_SESSION_CHILD = 1053441,
  TASK_TYPE_TROUBLESHOOT_CANCEL_TASK_PARENT = 1053696,
  TASK_TYPE_TROUBLESHOOT_CANCEL_TASK_CHILD = 1053697,
  TASK_TYPE_TROUBLESHOOT_FORCE_STOP_PARENT = 1053952,
  TASK_TYPE_MOVE_ENDPOINT_PARENT = 1054464,
  TASK_TYPE_MOVE_ENDPOINT_CHILD = 1054465,
  TASK_TYPE_RANSOMWARE_RESTORE_FILES_PARENT = 1056768,
  TASK_TYPE_RANSOMWARE_RESTORE_FILES_CHILD = 1056769,
  TASK_TYPE_COLLECT_INVESTIGATION_PACKAGE_PARENT = 2320,
  TASK_TYPE_COLLECT_INVESTIGATION_PACKAGE_CHILD = 2321,
  TASK_TYPE_COLLECT_INVESTIGATION_PACKAGE_CANCEL_TASK_PARENT = 2576,
  TASK_TYPE_COLLECT_INVESTIGATION_PACKAGE_CANCEL_TASK_CHILD = 2577,
  TASK_TYPE_LOCK_PARENT = 1024,
  TASK_TYPE_UNLOCK_PARENT = 1025,
  TASK_TYPE_WIPE_PARENT = 1026,
  TASK_TYPE_MDM_SCAN_PARENT = 1027,
  TASK_TYPE_LOCATE_PARENT = 1028,
  TASK_TYPE_PAUSE_INTEGRITY_MONITORING_PARENT = 1057024,
  TASK_TYPE_RESUME_INTEGRITY_MONITORING_PARENT = 1057026,

  TASK_TYPE_REMOTE_ACCESS_DOWNLOAD_CHILD = 1057280,
  TASK_TYPE_REMOTE_ACCESS_DOWNLOAD_PARENT = 1057281,

  TASK_TYPE_REMOTE_ACCESS_UPLOAD_BY_ENDPOINT_CHILD = 1057536,
  TASK_TYPE_REMOTE_ACCESS_UPLOAD_BY_ENDPOINT_PARENT = 1057537,

  TASK_TYPE_REMOTE_ACCESS_CANCEL_UPLOAD_CHILD = 1057792,
  TASK_TYPE_REMOTE_ACCESS_CANCEL_UPLOAD_PARENT = 1057793,

  TASK_TYPE_RESTORE_ORIGINAL_QUARANTINE_EXCHANGE_PARENT = 1058048,
  TASK_TYPE_RESTORE_ORIGINAL_QUARANTINE_EXCHANGE_CHILD = 1058049,

  TASK_TYPE_RETRIEVE_QUARANTINE_FILE_CHILD = 1058305,
  TASK_TYPE_RETRIEVE_QUARANTINE_FILE_PARENT = 1058304,

  TASK_TYPE_SUBMIT_TO_SANDBOX_PARENT = 1058560,
  TASK_TYPE_SUBMIT_TO_SANDBOX_CHILD = 1058561,

  TASK_TYPE_RUN_LIVE_SEARCH_QUERY_PARENT = 1058816,
  TASK_TYPE_RUN_LIVE_SEARCH_QUERY_CHILD = 1058817,

  TASK_TYPE_SUSPEND_PROTECTION_PARENT = 1059072,
  TASK_TYPE_SUSPEND_PROTECTION_CHILD = 1059073,
  TASK_TYPE_RESUME_PROTECTION_PARENT = 1060864,
  TASK_TYPE_RESUME_PROTECTION_CHILD = 1060865,

  TASK_TYPE_REMOTE_ACCESS_START_PROCESS_PARENT = 1061120, // 0x103100
  TASK_TYPE_REMOTE_ACCESS_START_PROCESS_CHILD = 1061121, // 0x103101

  TASK_TYPE_UPDATE_BEHAVIOR_ACTIONS_PARENT = 1058820,
  TASK_TYPE_UPDATE_BEHAVIOR_ACTIONS_CHILD = 1058821,
}

export enum ScanTaskScanType {
  YARA = 518,
}

export function getTaskTypeLabel(taskType: TaskType, translateFn: Function): string {
  const TaskTypeLabels: Record<TaskType | number, string> = {
    [TaskType.TASK_TYPE_SCAN_PARENT]: translateFn('Malware scan'),
    [TaskType.TASK_TYPE_SCAN_EXCHANGE_PARENT]: translateFn('Exchange scan'),
    [TaskType.TASK_TYPE_INSTALL_ENDPOINT_PARENT]: translateFn('Install agent'),
    [TaskType.TASK_TYPE_INSTALL_ENDPOINT_SUPA_PARENT]: translateFn('Install agent'),
    [TaskType.TASK_TYPE_INSTALL_EPS_PARENT]: translateFn('Install agent'),
    [TaskType.TASK_TYPE_INSTALL_EPS_SUPA_PARENT]: translateFn('Install agent'),
    [TaskType.TASK_TYPE_INSTALL_SAGENT_PARENT]: translateFn('Install agent'),
    [TaskType.TASK_TYPE_RESTART_ENDPOINT_PARENT]: translateFn('Restart endpoint'),
    [TaskType.TASK_TYPE_DELETE_ENDPOINT_PARENT]: translateFn('Delete endpoint'),
    [TaskType.TASK_TYPE_RESTORE_QUARANTINE_PARENT]: translateFn('Restore quarantined files'),
    [TaskType.TASK_TYPE_REMOVE_QUARANTINE_PARENT]: translateFn('Delete quarantined files'),
    [TaskType.TASK_TYPE_REMOVE_ALL_QUARANTINE_EXCHANGE_PARENT]: translateFn('Empty Exchange Quarantine'),
    [TaskType.TASK_TYPE_REMOVE_ALL_QUARANTINE_PARENT]: translateFn('Empty Quarantine'),
    [TaskType.TASK_TYPE_ADD_QUARANTINE_PARENT]: translateFn('Add to Quarantine'),
    [TaskType.TASK_TYPE_REMOVE_QUARANTINE_EXCHANGE_PARENT]: translateFn('Delete quarantined Exchange files'),
    [TaskType.TASK_TYPE_RESTORE_QUARANTINE_EXCHANGE_PARENT]: translateFn(
      'Release the Exchange quarantined item as attachment'
    ),
    [TaskType.TASK_TYPE_RESTORE_ORIGINAL_QUARANTINE_EXCHANGE_PARENT]: translateFn(
      'Release the Exchange quarantined item to recipients'
    ),
    [TaskType.TASK_TYPE_SAVE_QUARANTINE_EXCHANGE_PARENT]: translateFn('Save quarantined Exchange files'),
    [TaskType.TASK_TYPE_UNINSTALL_ENDPOINT_PARENT]: translateFn('Uninstall agent'),
    [TaskType.TASK_TYPE_UPDATE_ENDPOINT_PARENT]: translateFn('Update agent'),
    [TaskType.TASK_TYPE_MODIFY_INSTALLER_ENDPOINT_PARENT]: translateFn('Reconfigure agent'),
    [TaskType.TASK_TYPE_NETWORK_DISCOVERY_PARENT]: translateFn('Run network discovery'),
    [TaskType.TASK_TYPE_APPLICATION_DISCOVERY_PARENT]: translateFn('Run applications discovery'),
    [TaskType.TASK_TYPE_DEPLOY_VMWARE_SVA_PARENT]: translateFn('Install Security Server'),
    [TaskType.TASK_TYPE_DEPLOY_XEN_SVA_PARENT]: translateFn('Install Security Server'),
    [TaskType.TASK_TYPE_UNDEPLOY_VMWARE_SVA_PARENT]: translateFn('Uninstall Security Server'),
    [TaskType.TASK_TYPE_UNDEPLOY_XEN_SVA_PARENT]: translateFn('Uninstall Security Server'),
    [TaskType.TASK_TYPE_DEPLOY_NUTANIX_SVA_PARENT]: translateFn('Install Security Server'),
    [TaskType.TASK_TYPE_UNDEPLOY_NUTANIX_SVA_PARENT]: translateFn('Uninstall Security Server'),
    [TaskType.TASK_TYPE_UPDATE_SVA_PARENT]: translateFn('Update Security Server'),
    [TaskType.TASK_TYPE_ADD_REMOVE_FEATURES_ENDPOINT_PARENT]: translateFn('Reconfigure agent'),
    [TaskType.TASK_TYPE_PATCH_SCAN_PARENT]: translateFn('Patch scan'),
    [TaskType.TASK_TYPE_PATCH_INSTALL_PARENT]: translateFn('Patch install'),
    [TaskType.TASK_TYPE_PATCH_UNINSTALL_PARENT]: translateFn('Patch uninstall'),
    [TaskType.TASK_TYPE_UPDATE_SANDBOX_PARENT]: translateFn('Update Sandbox Analyzer'),
    [TaskType.TASK_TYPE_UPDATE_GHOSTR_PARENT]: translateFn('Update Network Security Virtual Appliance'),
    [TaskType.TASK_TYPE_BUILD_DETONATION_IMAGE_PARENT]: translateFn('Sandbox Analyzer - Build Image'),
    [TaskType.TASK_TYPE_SET_DEFAULT_DETONATION_IMAGE_PARENT]: translateFn('Sandbox Analyzer - Set as Default'),
    [TaskType.TASK_TYPE_DELETE_DETONATION_IMAGE_PARENT]: translateFn('Sandbox Analyzer - Delete Image'),
    [TaskType.TASK_TYPE_KILL_PROCESS_PARENT]: translateFn('Kill process'),
    [TaskType.TASK_TYPE_ISOLATE_ENDPOINT_PARENT]: translateFn('Isolate endpoint'),
    [TaskType.TASK_TYPE_RESTORE_ENDPOINT_PARENT]: translateFn('Remove from isolation'),
    [TaskType.TASK_TYPE_ISOLATE_ENDPOINT_CHILD]: translateFn('Remove from isolation'),
    [TaskType.TASK_TYPE_IOR_SCAN_PARENT]: translateFn('Risk scan'),
    [TaskType.TASK_TYPE_IOR_FIX_PARENT]: translateFn('Risk fix'),
    [TaskType.TASK_TYPE_IOR_ROLLBACK_PARENT]: translateFn('Roll back fixes'),
    [TaskType.TASK_TYPE_IOC_SCAN_PARENT]: translateFn('IOC scan'),
    [TaskType.TASK_TYPE_MOVE_ENDPOINT_PARENT]: translateFn('Move endpoint'),
    [TaskType.TASK_TYPE_SANDBOX_FILE_SUBMISSION_PARENT]: translateFn('Sandbox file submission'),
    [TaskType.TASK_TYPE_REPAIR_ENDPOINT_PARENT]: translateFn('Repair agent'),
    [TaskType.TASK_TYPE_RANSOMWARE_RESTORE_FILES_PARENT]: translateFn('Restore encrypted files'),
    [TaskType.TASK_TYPE_LOCK_PARENT]: translateFn('Lock'),
    [TaskType.TASK_TYPE_UNLOCK_PARENT]: translateFn('Unlock'),
    [TaskType.TASK_TYPE_WIPE_PARENT]: translateFn('Wipe'),
    [TaskType.TASK_TYPE_MDM_SCAN_PARENT]: translateFn('Scan'),
    [TaskType.TASK_TYPE_LOCATE_PARENT]: translateFn('Locate'),
    [TaskType.TASK_TYPE_PAUSE_INTEGRITY_MONITORING_PARENT]: translateFn('Suspend Integrity Monitoring'),
    [TaskType.TASK_TYPE_RESUME_INTEGRITY_MONITORING_PARENT]: translateFn('Resume Integrity Monitoring'),
    [TaskType.TASK_TYPE_REMOTE_ACCESS_DOWNLOAD_PARENT]: translateFn('Upload files'),
    [TaskType.TASK_TYPE_RETRIEVE_QUARANTINE_FILE_PARENT]: translateFn('Retrieve quarantined files'),
    [TaskType.TASK_TYPE_SUBMIT_TO_SANDBOX_PARENT]: translateFn('Submit to Sandbox Analyzer'),
    [TaskType.TASK_TYPE_RUN_LIVE_SEARCH_QUERY_PARENT]: translateFn('Run Live Search query'),
    [TaskType.TASK_TYPE_SUSPEND_PROTECTION_PARENT]: translateFn('Suspend endpoint protection'),
    [TaskType.TASK_TYPE_RESUME_PROTECTION_PARENT]: translateFn('Resume endpoint protection'),
    [TaskType.TASK_TYPE_REMOTE_ACCESS_START_PROCESS_PARENT]: translateFn('Run command'),
    [TaskType.TASK_TYPE_UPDATE_BEHAVIOR_ACTIONS_PARENT]: translateFn('Recommendation handling'),
  };
  return TaskTypeLabels[taskType];
}

export const TaskTypesAvailableForCloudAndOnPremisePlatforms = [
  TaskType.TASK_TYPE_SCAN_PARENT,
  TaskType.TASK_TYPE_PATCH_SCAN_PARENT,
  TaskType.TASK_TYPE_PATCH_INSTALL_PARENT,
  TaskType.TASK_TYPE_PATCH_UNINSTALL_PARENT,
  TaskType.TASK_TYPE_INSTALL_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_REPAIR_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_UPDATE_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_RESTART_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_DELETE_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_UNINSTALL_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_MODIFY_INSTALLER_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_NETWORK_DISCOVERY_PARENT,
  TaskType.TASK_TYPE_REMOVE_QUARANTINE_PARENT,
  TaskType.TASK_TYPE_ADD_QUARANTINE_PARENT,
  TaskType.TASK_TYPE_RESTORE_QUARANTINE_PARENT,
  TaskType.TASK_TYPE_REMOVE_ALL_QUARANTINE_PARENT,
  TaskType.TASK_TYPE_RANSOMWARE_RESTORE_FILES_PARENT,
  TaskType.TASK_TYPE_PAUSE_INTEGRITY_MONITORING_PARENT,
  TaskType.TASK_TYPE_RESUME_INTEGRITY_MONITORING_PARENT,
  TaskType.TASK_TYPE_SUSPEND_PROTECTION_PARENT,
  TaskType.TASK_TYPE_RESUME_PROTECTION_PARENT,
];

export const TaskTypesAvailableOnlyForCloudPlatform = [
  TaskType.TASK_TYPE_MOVE_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_RETRIEVE_QUARANTINE_FILE_PARENT,
];

export const TaskTypesAvailableOnlyForOnPremisePlatform = [];

export const TaskTypesAvailableOnlyForCloudPlatformAndForFeature: Record<Feature | number, Array<TaskType>> = {
  [Feature.PRODUCT_FEATURE_EXCHANGE]: [
    TaskType.TASK_TYPE_SCAN_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_REMOVE_QUARANTINE_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_RESTORE_QUARANTINE_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_RESTORE_ORIGINAL_QUARANTINE_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_SAVE_QUARANTINE_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_REMOVE_ALL_QUARANTINE_EXCHANGE_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING]: [TaskType.TASK_TYPE_UPDATE_SVA_PARENT],
  [Feature.PRODUCT_FEATURE_SANDBOX_LOCAL_VISIBLE]: [
    TaskType.TASK_TYPE_UPDATE_SANDBOX_PARENT,
    TaskType.TASK_TYPE_BUILD_DETONATION_IMAGE_PARENT,
    TaskType.TASK_TYPE_SET_DEFAULT_DETONATION_IMAGE_PARENT,
    TaskType.TASK_TYPE_DELETE_DETONATION_IMAGE_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_SANDBOX_ANALYZER_VISIBLE]: [TaskType.TASK_TYPE_SUBMIT_TO_SANDBOX_PARENT],
  [Feature.PRODUCT_FEATURE_ISOLATION_VISIBLE]: [
    TaskType.TASK_TYPE_ISOLATE_ENDPOINT_PARENT,
    TaskType.TASK_TYPE_RESTORE_ENDPOINT_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_ANY_EDR_VISIBLE]: [
    TaskType.TASK_TYPE_KILL_PROCESS_PARENT,
    TaskType.TASK_TYPE_SANDBOX_FILE_SUBMISSION_PARENT,
    TaskType.TASK_TYPE_IOC_SCAN_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_IOR_VISIBLE]: [
    TaskType.TASK_TYPE_IOR_SCAN_PARENT,
    TaskType.TASK_TYPE_IOR_FIX_PARENT,
    TaskType.TASK_TYPE_IOR_ROLLBACK_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_GHOSTR_VISIBLE]: [TaskType.TASK_TYPE_UPDATE_GHOSTR_PARENT],
  [Feature.PRODUCT_FEATURE_APPLICATION_CONTROL]: [TaskType.TASK_TYPE_APPLICATION_DISCOVERY_PARENT],
  [Feature.PRODUCT_FEATURE_REMOTE_ACCESS]: [TaskType.TASK_TYPE_REMOTE_ACCESS_DOWNLOAD_PARENT],
  [Feature.PRODUCT_FEATURE_LIVE_SEARCH_VISIBLE]: [TaskType.TASK_TYPE_RUN_LIVE_SEARCH_QUERY_PARENT],
  [Feature.PRODUCT_FEATURE_PHASR_VISIBLE]: [TaskType.TASK_TYPE_UPDATE_BEHAVIOR_ACTIONS_PARENT]
};

export const TaskTypesAvailableOnlyForOnPremisePlatformAndForFeature: Record<Feature | number, Array<TaskType>> = {
  [Feature.PRODUCT_FEATURE_EXCHANGE]: [
    TaskType.TASK_TYPE_SCAN_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_REMOVE_QUARANTINE_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_RESTORE_QUARANTINE_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_RESTORE_ORIGINAL_QUARANTINE_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_SAVE_QUARANTINE_EXCHANGE_PARENT,
    TaskType.TASK_TYPE_REMOVE_ALL_QUARANTINE_EXCHANGE_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_SANDBOX_LOCAL_VISIBLE]: [
    TaskType.TASK_TYPE_UPDATE_SANDBOX_PARENT,
    TaskType.TASK_TYPE_BUILD_DETONATION_IMAGE_PARENT,
    TaskType.TASK_TYPE_SET_DEFAULT_DETONATION_IMAGE_PARENT,
    TaskType.TASK_TYPE_DELETE_DETONATION_IMAGE_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_ISOLATION_VISIBLE]: [
    TaskType.TASK_TYPE_ISOLATE_ENDPOINT_PARENT,
    TaskType.TASK_TYPE_RESTORE_ENDPOINT_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_ANY_EDR_VISIBLE]: [
    TaskType.TASK_TYPE_KILL_PROCESS_PARENT,
    TaskType.TASK_TYPE_SANDBOX_FILE_SUBMISSION_PARENT,
    TaskType.TASK_TYPE_IOC_SCAN_PARENT,
  ],
  [Feature.PRODUCT_FEATURE_IOR_VISIBLE]: [TaskType.TASK_TYPE_IOR_SCAN_PARENT, TaskType.TASK_TYPE_IOR_FIX_PARENT],
  [Feature.PRODUCT_FEATURE_GHOSTR_VISIBLE]: [TaskType.TASK_TYPE_UPDATE_GHOSTR_PARENT],
  [Feature.PRODUCT_FEATURE_APPLICATION_CONTROL]: [TaskType.TASK_TYPE_APPLICATION_DISCOVERY_PARENT],
  [Feature.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING]: [
    TaskType.TASK_TYPE_UPDATE_SVA_PARENT,
    TaskType.TASK_TYPE_DEPLOY_VMWARE_SVA_PARENT,
    TaskType.TASK_TYPE_UNDEPLOY_VMWARE_SVA_PARENT,
  ],
};

export enum TaskStatus {
  STATUS_PENDING = 0,
  STATUS_PROCESSING = 1,
  STATUS_STOPPED = 2,
  STATUS_PROCESSED = 3,
  STATUS_RETRYING = 4,
  STATUS_STOPPED_BY_USER = 5,
  STATUS_DOWNLOADING = 6,
  STATUS_START_DOWNLOAD_FRAMEWORK = 200,
  STATUS_FINISH_DOWNLOAD_FRAMEWORK = 201,

  STATUS_START_REMOVE_COMPETITION = 202,
  STATUS_FINISH_REMOVE_COMPETITION = 203,
  STATUS_START_REMOVE_OLD_VERSION = 204,
  STATUS_FINISH_REMOVE_OLD_VERSION = 205,
  STATUS_START_SCAN = 206,
  STATUS_FINISH_SCAN = 207,
  STATUS_REBOOT_INITIATED_BY_USER = 208,
  STATUS_REBOOT_NEEDED = 209,
  STATUS_START_INSTALL = 210,
  STATUS_STOP_INSTALL = 211,
  STATUS_REMOTE_TASK_WAITING_FOR_FREE_SLOTS = 101,
  STATUS_REMOTE_TASK_STARTING_CONFIGURE = 103,
  STATUS_REMOTE_TASK_FINISHED_CONFIGURE = 104,
  STATUS_REMOTE_TASK_STARTING_RESOLVING_HOSTS_IP = 105,
  STATUS_REMOTE_TASK_FINISHED_RESOLVING_HOSTS_IP = 106,
  STATUS_REMOTE_TASK_STARTING_DETECT_OS = 107,
  STATUS_REMOTE_TASK_FINISHED_DETECT_OS = 108,
  STATUS_REMOTE_TASK_STARTING_SORT_VALID_TARGETS = 109,
  STATUS_REMOTE_TASK_FINISHED_SORT_VALID_TARGETS = 110,
  STATUS_REMOTE_TASK_STARTING_RUN_TASKS_PER_TARGET = 111,
  STATUS_REMOTE_TASK_STARTING_PRETASK_PER_TARGET = 115,
  STATUS_REMOTE_TASK_FINISHED_PRETASK_PER_TARGET = 116,
  STATUS_REMOTE_TASK_STARTING_DOWNLOAD_KIT_PER_TARGET = 117,
  STATUS_REMOTE_TASK_FINISHED_DOWNLOAD_KIT_PER_TARGET = 118,
  STATUS_REMOTE_TASK_STARTING_DEPLOYMENT_PER_TARGET = 119,
  STATUS_REMOTE_TASK_STOPPED = 198,
  STATUS_REMOTE_TASK_END_RUN_TASK = 199,
}

export const TaskStatusValues: Array<TaskStatus> = [
  TaskStatus.STATUS_PENDING,
  TaskStatus.STATUS_PROCESSING,
  TaskStatus.STATUS_PROCESSED,
];

export function getTaskStatusLabel(taskStatus: TaskStatus, translateFn: Function) {
  const TaskStatusLabels: Record<TaskStatus | number, string> = {
    [TaskStatus.STATUS_PENDING]: translateFn('Pending'),
    [TaskStatus.STATUS_PROCESSING]: translateFn('In Progress'),
    [TaskStatus.STATUS_STOPPED]: translateFn('Failed'),
    [TaskStatus.STATUS_PROCESSED]: translateFn('Finished'),
    [TaskStatus.STATUS_RETRYING]: translateFn('Retrying'),
    [TaskStatus.STATUS_STOPPED_BY_USER]: translateFn('Stopping'),
    [TaskStatus.STATUS_DOWNLOADING]: translateFn('Downloading...'),
    [TaskStatus.STATUS_START_DOWNLOAD_FRAMEWORK]: translateFn('Start downloading framework'),
    [TaskStatus.STATUS_FINISH_DOWNLOAD_FRAMEWORK]: translateFn('Finished downloading framework'),
    [TaskStatus.STATUS_START_REMOVE_COMPETITION]: translateFn('Removing competitor'),
    [TaskStatus.STATUS_FINISH_REMOVE_COMPETITION]: translateFn('Finished removing competitor'),
    [TaskStatus.STATUS_START_REMOVE_OLD_VERSION]: translateFn('Removing old version'),
    [TaskStatus.STATUS_FINISH_REMOVE_OLD_VERSION]: translateFn('Finished removing old version'),
    [TaskStatus.STATUS_START_SCAN]: translateFn('Scan started'),
    [TaskStatus.STATUS_FINISH_SCAN]: translateFn('Finished scan'),
    [TaskStatus.STATUS_REBOOT_INITIATED_BY_USER]: translateFn('Reboot initiated by user'),
    [TaskStatus.STATUS_REBOOT_NEEDED]: translateFn('Reboot required'),
    [TaskStatus.STATUS_START_INSTALL]: translateFn('Install started'),
    [TaskStatus.STATUS_STOP_INSTALL]: translateFn('Install finished'),
    [TaskStatus.STATUS_REMOTE_TASK_WAITING_FOR_FREE_SLOTS]: translateFn('Waiting for free slots'),
    [TaskStatus.STATUS_REMOTE_TASK_STARTING_CONFIGURE]: translateFn('Start configure'),
    [TaskStatus.STATUS_REMOTE_TASK_FINISHED_CONFIGURE]: translateFn('Stop Configure'),
    [TaskStatus.STATUS_REMOTE_TASK_STARTING_RESOLVING_HOSTS_IP]: translateFn('Start resolving hosts IP'),
    [TaskStatus.STATUS_REMOTE_TASK_FINISHED_RESOLVING_HOSTS_IP]: translateFn('Stop resolving hosts IP'),
    [TaskStatus.STATUS_REMOTE_TASK_STARTING_DETECT_OS]: translateFn('Start detecting OS'),
    [TaskStatus.STATUS_REMOTE_TASK_FINISHED_DETECT_OS]: translateFn('Stop detecting OS'),
    [TaskStatus.STATUS_REMOTE_TASK_STARTING_SORT_VALID_TARGETS]: translateFn('Start sorting valid targets'),
    [TaskStatus.STATUS_REMOTE_TASK_FINISHED_SORT_VALID_TARGETS]: translateFn('Stop sorting valid targets'),
    [TaskStatus.STATUS_REMOTE_TASK_STARTING_RUN_TASKS_PER_TARGET]: translateFn('Start task per target'),
    [TaskStatus.STATUS_REMOTE_TASK_STARTING_PRETASK_PER_TARGET]: translateFn('Start pre task'),
    [TaskStatus.STATUS_REMOTE_TASK_FINISHED_PRETASK_PER_TARGET]: translateFn('Stop pre task'),
    [TaskStatus.STATUS_REMOTE_TASK_STARTING_DOWNLOAD_KIT_PER_TARGET]: translateFn('Start downloading kit'),
    [TaskStatus.STATUS_REMOTE_TASK_FINISHED_DOWNLOAD_KIT_PER_TARGET]: translateFn('Finished downloading kit'),
    [TaskStatus.STATUS_REMOTE_TASK_STARTING_DEPLOYMENT_PER_TARGET]: translateFn('Start deployment'),
    [TaskStatus.STATUS_REMOTE_TASK_STOPPED]: translateFn('Stop deployment'),
    [TaskStatus.STATUS_REMOTE_TASK_END_RUN_TASK]: translateFn('Stop run task'),
  };
  return TaskStatusLabels[taskStatus];
}

export enum TasksGridEvents {
  CLICK_ON_REPORT_ICON = 'clickOnReportIcon',
  CLICK_ON_STATUS = 'clickOnStatus',
  SHOW_SUB_TASKS_PAGE = 'showSubTasksPage',
  HIDE_SUB_TASKS_PAGE = 'hideSubTasksPage',
}

export const RetryTasks: Array<TaskType> = [
  TaskType.TASK_TYPE_INSTALL_ENDPOINT_SUPA_PARENT,
  TaskType.TASK_TYPE_INSTALL_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_SCAN_PARENT,
  TaskType.TASK_TYPE_MODIFY_INSTALLER_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_UNINSTALL_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_UPDATE_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_RESTART_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_NETWORK_DISCOVERY_PARENT,
  TaskType.TASK_TYPE_APPLICATION_DISCOVERY_PARENT,
  TaskType.TASK_TYPE_PATCH_SCAN_PARENT,
  TaskType.TASK_TYPE_PATCH_INSTALL_PARENT,
  TaskType.TASK_TYPE_PATCH_UNINSTALL_PARENT,

  TaskType.TASK_TYPE_INSTALL_EPS_SUPA_PARENT,
  TaskType.TASK_TYPE_INSTALL_EPS_PARENT,

  TaskType.TASK_TYPE_INSTALL_SAGENT_PARENT,

  TaskType.TASK_TYPE_IOR_SCAN_PARENT,
  TaskType.TASK_TYPE_IOR_FIX_PARENT,
  TaskType.TASK_TYPE_IOR_ROLLBACK_PARENT,

  TaskType.TASK_TYPE_IOC_SCAN_PARENT,

  TaskType.TASK_TYPE_REPAIR_ENDPOINT_PARENT,

  TaskType.TASK_TYPE_ISOLATE_ENDPOINT_PARENT,
  TaskType.TASK_TYPE_RESTORE_ENDPOINT_PARENT,

  TaskType.TASK_TYPE_PAUSE_INTEGRITY_MONITORING_PARENT,
  TaskType.TASK_TYPE_RESUME_INTEGRITY_MONITORING_PARENT,
];

export enum TaskErrorCodes {
  ERROR_CODE_SVA_IMAGE_COULD_NOT_BE_DEPLOYED = 0x10078,
  ERROR_CODE_PATCH_TASK_13 = 13,
  ERROR_CODE_PATCH_TASK_21 = 21,
  ERROR_CODE_PATCH_TASK_87 = 87,
  ERROR_CODE_PATCH_TASK_126 = 126,
  ERROR_CODE_PATCH_TASK_995 = 995,
  ERROR_CODE_PATCH_TASK_1150 = 1150,
  ERROR_CODE_PATCH_TASK_1247 = 1247,
  ERROR_CODE_PATCH_TASK_2147942450 = 2147942450,
  ERROR_CODE_PATCH_TASK_1 = 1,
  ERROR_CODE_PATCH_TASK_160 = 160,
}

export enum SubmitToSandboxTaskErrorCodes {
  ERROR_NEGATIVE_1 = -1,
  ERROR_6 = 6,
  ERROR_7 = 7,
  ERROR_8 = 8,
}

export enum TaskSelectionStatus {
  SINGLE_PENDING = 1,
  SINGLE_IN_PROGRESS = 2,
  SINGLE_FINISHED = 3,

  ALL_PENDING = 4,
  ALL_IN_PROGRESS = 5,
  ALL_FINISHED = 6,

  PENDING_AND_IN_PROGRESS = 7,
  PENDING_AND_FINISHED = 8,
  FINISHED_AND_IN_PROGRESS = 9,
  ALL_STATUSES = 10,
}

export interface GridSelectionStatuses {
  [TaskStatus.STATUS_PENDING]: number;
  [TaskStatus.STATUS_PROCESSING]: number;
  [TaskStatus.STATUS_PROCESSED]: number;
}

export const KnowledgeBaseArticles = {
  supportForNutanixSvaDeployLinks: {
    fr_FR:
      'https://www.bitdefender.fr/support/How-to-manually-upload-Bitdefender-Security-Server-in-Nutanix-Prism-2179.html',
    de_DE:
      'https://www.bitdefender.de/support/How-to-manually-upload-Bitdefender-Security-Server-in-Nutanix-Prism-2179.html',
    es_ES:
      'https://www.bitdefender.es/support/How-to-manually-upload-Bitdefender-Security-Server-in-Nutanix-Prism-2179.html',
    it_IT:
      'https://www.bitdefender.it/support/How-to-manually-upload-Bitdefender-Security-Server-in-Nutanix-Prism-2179.html',
    ro_RO:
      'https://www.bitdefender.ro/support/How-to-manually-upload-Bitdefender-Security-Server-in-Nutanix-Prism-2179.html',
    pt_BR:
      'https://www.bitdefender.com.br/support/How-to-manually-upload-Bitdefender-Security-Server-in-Nutanix-Prism-2179.html',
    default:
      'https://www.bitdefender.com/support/How-to-manually-upload-Bitdefender-Security-Server-in-Nutanix-Prism-2179.html',
  },
  supportForBestDeployLinksBaseUrl:
    'https://www.bitdefender.com/business/support/en/77209-157537-best-deployments-errors-on-windows-machines.html',
  supportForPatchManagementErrorCodesCloudCustomer:
    'https://www.bitdefender.com/business/support/en/77209-343070-error-codes-for-gravityzone-patch-management.html',
  supportForPatchManagementErrorCodesCloudPartner:
    'https://www.bitdefender.com/business/support/en/77211-343070-error-codes-for-gravityzone-patch-management.html',
  supportForPatchManagementErrorCodesOnPremise:
    'https://www.bitdefender.com/business/support/en/77212-343070-error-codes-for-gravityzone-patch-management.html',
  sandboxAnalyzer: {
    imageManagementErrorsLinks: {
      default: 'https://www.bitdefender.com/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      en_US: 'https://www.bitdefender.com/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      cs_CZ: 'https://www.bitdefender.com/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      de_DE: 'https://www.bitdefender.de/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      es_ES: 'https://www.bitdefender.es/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      fr_FR: 'https://www.bitdefender.fr/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      it_IT: 'https://www.bitdefender.it/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      pl_PL: 'https://www.bitdefender.com/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      pt_BR: 'https://www.bitdefender.com/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      ro_RO: 'https://www.bitdefender.ro/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
      ru_RU: 'https://www.bitdefender.com/support/Sandbox-Analyzer-Image-Management-Error-Codes-2415.html',
    },
  },
};
